import React, { useState } from 'react';
import {
    TextField,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Paper,
    Typography,
    InputAdornment
} from '@mui/material';

import {
    FaVideo,
    FaYoutube,
    FaPodcast,
    FaBook,
    FaLanguage,
} from 'react-icons/fa';

import { Title, Link } from '@mui/icons-material';

import { supabase } from '../../../supabaseClient';

const SaveContent = ({ library, setLibrary }) => {
    const [formData, setFormData] = useState({
        title: '',
        url: '',
        type: '',
        language: '',
    });

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const newItem = { ...formData };

        // Guardar los datos en la tabla "library" de Supabase
        const { data, error } = await supabase.from('library').insert([newItem]);

        if (error) {
            console.error('Error al guardar el contenido:', error);
        } else {
            // Actualizar la biblioteca localmente con los nuevos datos guardados
            setLibrary([...library, newItem]);
            setFormData({ title: '', url: '', type: '', language: '' });
        }
    };

    const getOptionIcon = (type) => {
        switch (type) {
            case 'video':
                return <FaVideo />;
            case 'youtube':
                return <FaYoutube />;
            case 'podcast':
                return <FaPodcast />;
            case 'book':
                return <FaBook />;
            case 'article':
                return <FaLanguage />;
            default:
                return null;
        }
    };

    return (
        <>
            <Paper sx={{ p: 2, mt: 2, display: 'flex', flexDirection: 'column' }}>
                <Typography variant='h5'> Agregar contenido</Typography>
                <form onSubmit={(e) => handleFormSubmit(e)}>
                <TextField
                    label="Título"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    margin="normal"
                />
                <TextField
                    label="URL"
                    name="url"
                    value={formData.url}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    margin="normal"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Link />
                            </InputAdornment>
                        ),
                    }}
                />

                <FormControl fullWidth required margin="normal">
                    <InputLabel id="type-label">Tipo</InputLabel>
                    <Select
                        labelId="type-label"
                        id="type"
                        name="type"
                        value={formData.type}
                        onChange={handleInputChange}
                    >
                        <MenuItem value="video">
                            {getOptionIcon('video')} Video externo
                        </MenuItem>
                        <MenuItem value="youtube">
                            {getOptionIcon('youtube')} Video de YouTube
                        </MenuItem>
                        <MenuItem value="podcast">
                            {getOptionIcon('podcast')} Podcast
                        </MenuItem>
                        <MenuItem value="book">
                            {getOptionIcon('book')} Libro
                        </MenuItem>
                        <MenuItem value="article">
                            {getOptionIcon('article')} Artículo
                        </MenuItem>
                    </Select>
                </FormControl>

                <FormControl fullWidth required margin="normal">
                    <InputLabel id="language-label">Idioma</InputLabel>
                    <Select
                        labelId="language-label"
                        id="language"
                        name="language"
                        value={formData.language}
                        onChange={handleInputChange}
                    >
                        <MenuItem value="en">English</MenuItem>
                        <MenuItem value="es">Español</MenuItem>
                    </Select>
                </FormControl>

                <Button
                    variant="contained"
                    type="submit"
                    style={{ marginTop: '1rem' }}
                >
                    Registrar contenido
                </Button>
            </form>
        </Paper >
        </>
    );
};

export default SaveContent;